export default {
  'pages.log.operation.title': '操作日志',
  'pages.log.operation.subtitle': '记录用户在系统中的操作行为，便于追踪和审计',

  // 列表列
  'pages.log.operation.column.realName': '操作人',
  'pages.log.operation.column.userName': '操作账号',
  'pages.log.operation.column.operModule': '操作模块',
  'pages.log.operation.column.operType': '操作类型',
  'pages.log.operation.column.requestMethod': '请求方法',
  'pages.log.operation.column.requestUrl': '请求路径',
  'pages.log.operation.column.ipAddress': 'IP 地址',
  'pages.log.operation.column.operLocation': '地理位置',
  'pages.log.operation.column.operStatus': '状态',
  'pages.log.operation.column.execTime': '耗时(ms)',
  'pages.log.operation.column.operTime': '操作时间',
  'pages.log.operation.column.operTimeRange': '操作时间区间',

  // 搜索
  'pages.log.operation.search.userName.placeholder': '模糊匹配',
  'pages.log.operation.search.operModule.placeholder': '模糊匹配',

  // 枚举
  'pages.log.operation.operType.INSERT': '新增',
  'pages.log.operation.operType.UPDATE': '修改',
  'pages.log.operation.operType.DELETE': '删除',
  'pages.log.operation.operType.SELECT': '查询',
  'pages.log.operation.operType.OTHER': '其他',
  'pages.log.operation.status.success': '成功',
  'pages.log.operation.status.fail': '失败',
};
